import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { ArrowLeft } from "lucide-react";
import { SavingsCalculator } from "@/components/SavingsCalculator";
import { SectorWizard } from "@/components/SectorWizard";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_solar-config/artifacts/j8etyapd_ChatGPT%20Image%2026%20feb%202026%2C%2011_13_48.png";

export default function CalculatorPage() {
  const navigate = useNavigate();
  const [showWizard, setShowWizard] = useState(false);

  useSEO({
    title: "Calcolatore Risparmio Fotovoltaico | Fotovoltaico Chiavi in Mano",
    description: "Calcola quanto puoi risparmiare con un impianto fotovoltaico per casa, azienda o PMI. Simulatore gratuito del risparmio energetico.",
    canonical: `${window.location.origin}/calcolatore`,
  });

  return (
    <div className="min-h-screen bg-white" data-testid="calculator-page">
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <a href="/" className="flex items-center gap-2.5" data-testid="calc-page-logo">
              <img src={LOGO_URL} alt="Fotovoltaico Chiavi in Mano" className="h-14 w-auto object-contain" />
              <span className="hidden sm:block text-lg font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Fotovoltaico Chiavi in Mano
              </span>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/")} className="text-sm text-slate-500 hover:text-emerald-600 flex items-center gap-1.5 transition-colors" data-testid="calc-page-back">
              <ArrowLeft className="w-4 h-4" /> Torna al sito
            </button>
            <button onClick={() => setShowWizard(true)} className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-full px-6 py-2.5 text-sm btn-scale shadow-lg shadow-emerald-500/25" data-testid="calc-page-cta">
              Richiedi Preventivo
            </button>
          </div>
        </div>
      </div>

      <SavingsCalculator onConfigureClick={() => setShowWizard(true)} />

      {showWizard && <SectorWizard onClose={() => setShowWizard(false)} />}
    </div>
  );
}
